module.exports = __webpack_public_path__ + "static/adam.bf960d53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/adam.jpg
// module id = 627
// module chunks = 159916935039157